import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getListPartnerService, getPayoutReady, getPayoutReadySummary, PayoutReadyRow } from "../../../../services/PartnerService";
import { ChainRow, getEntitiesOfPartners, listChains, PartnerEntitySummary } from "../../../../services/LegalEntityService";
import PartnerTableBody from "./PartnerTableBody";
import Partner from "../../../../models/Partner";
import DialogUpdatePartnerAdmin from "./DialogUpdatePartnerAdmin";
import DialogInfoPartnerAdmin from "./DialogInfoPartner";
import DialogImagesPartner from "./DialogImagesPartner";
import DialogReviewsPartner from "./DialogReviewsPartner";
import DialogTrustItemsPartner from "./DialogTrustItemsPartner";
import DialogFeaturesPartner from "./DialogFeaturesPartner";
import DialogWalkingDistancePartner from "./DialogWalkingDistancePartner";
import DialogUpdatePartnerFinancialFields from "./DialogUpdatePartnerFinancialFields";
import DialogBulkUpdatePartnerAdmin from "./DialogBulkUpdatePartnerAdmin";
import DialogBanPartner from "./DialogBanPartner";
import { docCheDoGon, ghiCheDoGon, suyLoaiTaiKhoan, laStation, locDanhSachTram, LocTram } from "./cheDoGon";
import { tenHienThiChuoi } from "./ChainsTable";
import { NHAN_PAYOUT } from "./PayoutReadyCell";

/* ── colour palette for grouped header bands ── */
const GRP = {
	station: { bg: "#e3f2fd", border: "#1976d2", text: "#1565c0" },
	account: { bg: "#f3e5f5", border: "#9c27b0", text: "#7b1fa2" },
	address: { bg: "#e8f5e9", border: "#43a047", text: "#2e7d32" },
	financial: { bg: "#fff3e0", border: "#fb8c00", text: "#e65100" },
	rate: { bg: "#fce4ec", border: "#e91e63", text: "#c2185b" },
	meta: { bg: "#eceff1", border: "#607d8b", text: "#37474f" },
	action: { bg: "#e0f7fa", border: "#00acc1", text: "#006064" },
};

const grpTh = (c: typeof GRP.station, extra?: React.CSSProperties): React.CSSProperties => ({
	background: c.bg,
	color: c.text,
	fontWeight: 700,
	fontSize: "11px",
	textTransform: "uppercase",
	letterSpacing: "0.5px",
	padding: "5px 6px",
	textAlign: "center",
	borderBottom: `2px solid ${c.border}`,
	borderRight: "1px solid #e0e0e0",
	...extra,
});

const colTh: React.CSSProperties = {
	background: "#fafafa",
	color: "#424242",
	fontWeight: 600,
	fontSize: "11.5px",
	padding: "7px 6px",
	textAlign: "center",
	borderBottom: "2px solid #e0e0e0",
	borderRight: "1px solid #f0f0f0",
	whiteSpace: "nowrap",
};

/* 20/10/2026 (test vai vận hành: mỗi lần "Stations →" chờ ~3 giây): nhớ danh sách TOÀN BỘ đã tải theo
   đúng bộ lọc URL trong lúc đang làm việc. Quay lại ⇒ hiện ngay bản đã nhớ, đồng thời vẫn tải bản mới
   ngầm rồi thay vào (không bao giờ kẹt dữ liệu cũ). Mất khi tải lại trang. */
const boNhoTatCa = new Map<string, Partner[]>();

export default function PartnerTable(props: {
	listUser: Partner[];
	reload: () => void;
	/** 18/10/2026: báo màn cha đang lọc theo loại (kết quả là TOÀN BỘ, không chia trang) ⇒ màn cha ẩn phân trang. */
	onDangLocLoai?: (dangLoc: boolean) => void;
	/** 18/10/2026: chuỗi đang chọn (điều khiển từ chế độ xem Chains → "Stations →"). Không truyền ⇒ tự giữ. */
	chuoiId?: number | null;
	onChuoiChange?: (id: number | null) => void;
}) {
	const [isDialogLoginOpen, setIsDialogLoginOpen] = useState(false);
	const [isDialogIfOpen, setIsDialogIfOpen] = useState(false);
	const [isDialogImages, setIsDialogImages] = useState(false);
	const [isDialogReviews, setIsDialogReviews] = useState(false);
	const [isDialogTrustItems, setIsDialogTrustItems] = useState(false);
	const [isDialogFeatures, setIsDialogFeatures] = useState(false);
	const [isDialogWalkingDistance, setIsDialogWalkingDistance] = useState(false);
	const [isDialogFinancialOpen, setIsDialogFinancialOpen] = useState(false);
	const [financialPartner, setFinancialPartner] = useState<Partner | null>(null);
	const [orderIdInfo, setOrderIdInfo] = useState("");
	const [orderId, setOrderId] = useState("");
	const [selectedIds, setSelectedIds] = useState<string[]>([]);
	const [isDialogBulkEdit, setIsDialogBulkEdit] = useState(false);
	const [banPartnerDialogOpen, setBanPartnerDialogOpen] = useState(false);
	const [banPartnerId, setBanPartnerId] = useState<string | null>(null);
	// Công tắc DỰNG THỬ (28/08): bật = bảng gọn theo đề xuất, tắt = bảng như hiện tại.
	const [gon, setGon] = useState<boolean>(docCheDoGon());
	// Bộ lọc theo LOẠI tài khoản — đề xuất 28/08, lọc ngay trên bảng nên không đụng API.
	const [locLoai, setLocLoai] = useState<LocTram>("");
	const [chuoiNoiBo, setChuoiNoiBo] = useState<number | null>(null);
	const chuoiId = props.chuoiId !== undefined ? props.chuoiId : chuoiNoiBo;
	const datChuoi = (id: number | null) => (props.onChuoiChange ? props.onChuoiChange(id) : setChuoiNoiBo(id));
	// 04/11/2026 (Quân): lọc Payout ready — lọc trên toàn bộ trạm như lọc loại.
	const [locPayout, setLocPayout] = useState("");
	const dangLoc = Boolean(locLoai || chuoiId || locPayout);
	/* 18/10/2026 (Quân: "in chain lọc có ra gì đâu"): trước đây lọc loại chỉ trong 50 trạm của TRANG đang
	   xem ⇒ trang 1 không có HK/Miraton thì "In chain" ra 0. Nay chọn loại ⇒ tải TOÀN BỘ trạm theo đúng
	   các bộ lọc khác đang có trên URL rồi mới lọc; bộ đếm cũng đếm trên toàn bộ. */
	const { search } = useLocation();
	const [tatCa, setTatCa] = useState<Partner[] | null>(null);
	useEffect(() => {
		props.onDangLocLoai?.(dangLoc);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dangLoc]);
	useEffect(() => {
		if (!dangLoc) {
			setTatCa(null);
			return;
		}
		const u = new URLSearchParams(search);
		let huy = false;
		setTatCa(boNhoTatCa.get(search) || null);
		getListPartnerService(
			1,
			2000,
			u.get("filterKeyword") || undefined,
			u.get("filterStates") ? decodeURIComponent(u.get("filterStates") || "") : "",
			u.get("filterStore") || "",
			u.get("filterUserIdString") || "",
			u.get("filterCountry") || undefined,
			u.get("filterDestinationId") || undefined,
			u.get("filterNoLocation") === "true",
			u.get("filterBanned")
		)
			.then((r) => {
				boNhoTatCa.set(search, r.data);
				if (!huy) setTatCa(r.data);
			})
			.catch(() => !huy && setTatCa(boNhoTatCa.get(search) || null));
		return () => {
			huy = true;
		};
	}, [dangLoc, search]);
	// Đang tải toàn bộ (~8 giây trên ~700 trạm) ⇒ KHÔNG hiện tạm kết quả của trang 1 (dễ tưởng lọc sai).
	const dangTaiTatCa = dangLoc && tatCa === null;
	const tatCaDaTai: Partner[] = dangLoc ? tatCa || [] : props.listUser;
	// Chọn một chuỗi ⇒ bộ đếm đếm trong chuỗi đó.
	const nguon: Partner[] = chuoiId ? locDanhSachTram(tatCaDaTai, "", chuoiId) : tatCaDaTai;

	// Đếm theo đúng giá trị server trả (nay là 5, khớp cột `lifecycleStatus`).
	// `activeCount` phải khớp `actived` — bản cũ đếm chuỗi "active" nên từ 25/08 sẽ ra 0.
	const demTheo = (gt: string) => nguon.filter((p) => String(p.status || "").toLowerCase() === gt).length;
	const publishedCount = demTheo("published");
	const activeCount = demTheo("actived");
	const inactiveCount = demTheo("inactive");
	const bannedCount = demTheo("banned");

	// ── Bản gọn: đếm theo ĐÚNG 5 trạng thái đang dùng, và tách chủ chuỗi ra ──
	// "Actived: 0" là con số vô nghĩa từ 25/08 (giá trị `actived` đã tách đôi).
	const approvedCount = demTheo("approved");
	const pausedCount = demTheo("paused");
	/* 17/10/2026 (B2 — bên ký làm gốc): tên chuỗi Admin đặt + bên ký của từng trạm, lấy qua API
	   riêng của màn "Legal entities & chains" — KHÔNG đổi /partners-by-admin (dùng chung với
	   cổng trạm, Workspace). Lỗi ⇒ bảng hiện như cũ. */
	const [tenChuoiTheoStore, setTenChuoiTheoStore] = useState<Record<number, string>>({});
	const [dsChuoi, setDsChuoi] = useState<ChainRow[]>([]);
	const [benKyTheoTram, setBenKyTheoTram] = useState<Record<number, PartnerEntitySummary>>({});
	useEffect(() => {
		listChains()
			.then((rows) => {
				setTenChuoiTheoStore(Object.fromEntries(rows.filter((c) => c.name).map((c) => [c.id, String(c.name)])));
				setDsChuoi(rows);
			})
			.catch(() => setTenChuoiTheoStore({}));
	}, []);
	const khoaTram = nguon.map((p) => Number(p.id)).filter((x) => x > 0).join(",");
	useEffect(() => {
		const ids = khoaTram ? khoaTram.split(",").map(Number) : [];
		if (!ids.length) return;
		getEntitiesOfPartners(ids)
			.then((rows) => setBenKyTheoTram(Object.fromEntries(rows.map((r) => [Number(r.partnerId), r]))))
			.catch(() => setBenKyTheoTram({}));
	}, [khoaTram]);
	const chuChuoiCount = nguon.filter((p) => suyLoaiTaiKhoan(p) === "chuChuoi").length;
	// 17/10/2026: "Stations" = mọi station, chỉ trừ tài khoản chủ chuỗi THUẦN (không nhận khách).
	// Bản cũ "Selling points" trừ MỌI chủ chuỗi ⇒ chủ chuỗi đang bán (HK Busline) bị đếm hụt.
	const soStation = nguon.filter(laStation).length;
	const truocLocPayout = dangLoc ? locDanhSachTram(tatCaDaTai, locLoai, chuoiId) : props.listUser;
	/* Cột Payout ready tải SAU bảng, qua API riêng ⇒ không làm chậm danh sách. Trang thường hỏi đúng các trạm đang hiện;
	   lọc Payout ready hoặc danh sách dài hơn 50 trạm ⇒ dùng bản tổng hợp (chỉ có trạm đang hoạt động). Lỗi ⇒ ô hiện "—". */
	const [payoutTheoTram, setPayoutTheoTram] = useState<Record<number, PayoutReadyRow>>({});
	const [dangTaiPayout, setDangTaiPayout] = useState(false);
	const khoaHienThi = truocLocPayout.map((p) => Number(p.id)).filter((x) => x > 0).join(",");
	useEffect(() => {
		const ids = khoaHienThi ? khoaHienThi.split(",").map(Number) : [];
		if (!ids.length) return;
		let huy = false;
		setDangTaiPayout(true);
		(locPayout || ids.length > 50 ? getPayoutReadySummary() : getPayoutReady(ids))
			.then((rows) => {
				if (!huy) setPayoutTheoTram((cu) => ({ ...cu, ...Object.fromEntries(rows.map((r) => [Number(r.partnerId), r])) }));
			})
			.catch(() => undefined)
			.finally(() => !huy && setDangTaiPayout(false));
		return () => {
			huy = true;
		};
	}, [khoaHienThi, locPayout]);
	const danhSach = locPayout
		? dangTaiPayout
			? []
			: truocLocPayout.filter((p) => payoutTheoTram[Number(p.id)]?.level === locPayout)
		: truocLocPayout;

	return (
		<div style={{ padding: "24px", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
			{/* ── Title bar ── */}
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					marginBottom: "14px",
				}}>
				<div
					style={{
						fontSize: "22px",
						fontWeight: 700,
						color: "#1a237e",
						display: "flex",
						alignItems: "center",
						gap: "8px",
					}}>
					🏪 Station Management
				</div>
				<div style={{ display: "flex", gap: "16px", fontSize: "13px", color: "#616161", alignItems: "center" }}>
					{selectedIds.length > 0 && (
						<button
							style={{
								padding: "7px 18px",
								background: "linear-gradient(135deg, #1e88e5 0%, #1565c0 100%)",
								color: "white",
								border: "none",
								borderRadius: "8px",
								fontWeight: 600,
								fontSize: "13px",
								cursor: "pointer",
								boxShadow: "0 3px 6px rgba(26, 35, 126, 0.15)",
								marginRight: "10px",
								transition: "all 0.2s ease",
							}}
							onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-1px)")}
							onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
							onClick={() => setIsDialogBulkEdit(true)}>
							Update Selected Stations ({selectedIds.length})
						</button>
					)}
					<button
						onClick={() => {
							const v = !gon;
							setGon(v);
							ghiCheDoGon(v);
						}}
						title="Bật/tắt bản gọn đang đề xuất — để so trước và sau ngay trên màn thật"
						style={{
							padding: "5px 12px",
							borderRadius: "16px",
							fontSize: "12px",
							fontWeight: 600,
							cursor: "pointer",
							border: gon ? "1px solid #1565c0" : "1px solid #cfd8dc",
							background: gon ? "#e3f2fd" : "#fff",
							color: gon ? "#0d47a1" : "#546e7a",
						}}>
						{gon ? "\u25CF B\u1EA2N G\u1ECCN (\u0111\u1EC1 xu\u1EA5t)" : "\u25CB B\u1EA2N \u0110\u1EA6Y \u0110\u1EE6 (hi\u1EC7n t\u1EA1i)"}
					</button>
					{/* 20/10/2026: 2 ô lọc hiện ở CẢ bản gọn lẫn bản đầy đủ — trước chỉ bản gọn có, ai dùng bản đầy đủ
					    mà bấm "Stations →" thì bảng bị lọc theo chuỗi không dấu hiệu gì. */}
							<select
								value={locLoai}
								onChange={(e) => setLocLoai(e.target.value as LocTram)}
								title="Lọc theo loại tài khoản"
								style={{
									padding: "5px 8px",
									borderRadius: "6px",
									border: "1px solid #cfd8dc",
									fontSize: "12px",
									color: "#37474f",
									background: "#fff",
								}}>
								<option value="">All types</option>
								<option value="single">Single</option>
								<option value="inChain">In a chain</option>
								<option value="chainAccount">Chain accounts</option>
							</select>
							<select
								value={chuoiId || ""}
								onChange={(e) => datChuoi(e.target.value ? Number(e.target.value) : null)}
								title="Show the stations of one chain"
								style={{
									padding: "5px 8px",
									borderRadius: "6px",
									border: "1px solid #cfd8dc",
									fontSize: "12px",
									color: "#37474f",
									background: "#fff",
									maxWidth: 220,
								}}>
								<option value="">All chains</option>
								{[...dsChuoi]
									.sort((a, b) => Number(b.chainModeEnabled) - Number(a.chainModeEnabled) || tenHienThiChuoi(a).localeCompare(tenHienThiChuoi(b)))
									.map((c) => (
										<option key={c.id} value={c.id}>
											{tenHienThiChuoi(c)} ({c.soDiem}){c.chainModeEnabled ? "" : " · OFF"}
										</option>
									))}
							</select>
							<select
								value={locPayout}
								onChange={(e) => setLocPayout(e.target.value)}
								title="Active stations by payout readiness"
								style={{
									padding: "5px 8px",
									borderRadius: "6px",
									border: "1px solid #cfd8dc",
									fontSize: "12px",
									color: "#37474f",
									background: "#fff",
								}}>
								<option value="">All payout status</option>
								{["ready", "waiting_signature", "missing"].map((k) => (
									<option key={k} value={k}>
										{NHAN_PAYOUT[k].label}
									</option>
								))}
							</select>
							{dangTaiTatCa || (locPayout && dangTaiPayout) ? <span style={{ color: "#667085" }}>Loading all stations…</span> : null}
					{gon ? (
						<>
							<span title="Every station, except chain owner accounts that take no bookings themselves">
								Stations: <strong style={{ color: "#1a237e" }}>{soStation}</strong>
							</span>
							<span>
								Published: <strong style={{ color: "#1565c0" }}>{publishedCount}</strong>
							</span>
							<span>
								Approved: <strong style={{ color: "#7b1fa2" }}>{approvedCount}</strong>
							</span>
							<span>
								Paused: <strong style={{ color: "#e65100" }}>{pausedCount}</strong>
							</span>
							<span>
								Closed: <strong style={{ color: "#546e7a" }}>{inactiveCount}</strong>
							</span>
							<span>
								Banned: <strong style={{ color: "#b71c1c" }}>{bannedCount}</strong>
							</span>
							<span style={{ color: "#7b1fa2" }}>
								Chain owners: <strong>{chuChuoiCount}</strong>
							</span>
						</>
					) : (
						<>
					<span>
						Total: <strong style={{ color: "#1a237e" }}>{props.listUser.length}</strong>
					</span>
					<span>
						Actived: <strong style={{ color: "#2e7d32" }}>{activeCount}</strong>
					</span>
					<span>
						Inactive: <strong style={{ color: "#c62828" }}>{inactiveCount}</strong>
					</span>
					<span>
						Published: <strong style={{ color: "#1565c0" }}>{publishedCount}</strong>
					</span>
					<span>
						Banned: <strong style={{ color: "#b71c1c" }}>{bannedCount}</strong>
					</span>
						</>
					)}
				</div>
			</div>

			{/* ── Table ── */}
			<div
				style={{
					overflow: "auto",
					borderRadius: "10px",
					boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
					border: "1px solid #e0e0e0",
					maxHeight: "calc(100vh - 300px)",
				}}>
				<table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px", minWidth: gon ? "1180px" : "2140px" }}>
					<thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
						{/* Group header row — bản gọn bỏ hẳn hàng 7 màu này */}
						{!gon && (
						<tr>
							<th
								style={grpTh(GRP.station)}
								/* 9 → 7 → 6 → 7 (04/11 thêm Payout ready). Nhóm Station 7 ô: chọn · ID · Status · Name ·
								   Display Name · Vi phạm HĐ (đã gỡ Meet tab · Nearby tab 29/08).
								   Đếm sai số này là cả hàng tiêu đề lệch khỏi cột bên dưới — đã
								   lệch một lần khi để 7. */
								colSpan={7}>
								🏪 Station
							</th>
							<th
								style={grpTh(GRP.account)}
								colSpan={2}>
								📧 Account
							</th>
							<th
								style={grpTh(GRP.address)}
								colSpan={2}>
								📍 Address
							</th>
							<th
								style={grpTh(GRP.financial)}
								colSpan={5}>
								💰 Financial
							</th>
							<th
								style={grpTh(GRP.rate)}
								colSpan={2}>
								📊 Rate Limits
							</th>
							<th
								style={grpTh(GRP.meta)}
								colSpan={1}>
								📅 Info
							</th>
							<th
								style={grpTh(GRP.action, { borderRight: "none" })}
								colSpan={1}>
								⚡ Actions
							</th>
						</tr>
						)}
						{/* Column header row */}
						<tr>
							{/* Station */}
							<th style={{ ...colTh, width: "40px" }}>
								<input
									type="checkbox"
									style={{ cursor: "pointer", width: "16px", height: "16px", accentColor: "#1a237e" }}
									checked={props.listUser.length > 0 && selectedIds.length === props.listUser.length}
									onChange={(e) => {
										if (e.target.checked) {
											setSelectedIds(props.listUser.map((p) => p.id || ""));
										} else {
											setSelectedIds([]);
										}
									}}
								/>
							</th>
							<th style={colTh}>ID</th>
							<th style={colTh}>Status</th>
							<th style={colTh} title="Licence approved + payout account right + digital signature valid">Payout ready</th>
							<th style={colTh}>Name</th>
							{gon && <th style={colTh}>Type</th>}
							{!gon && <th style={colTh}>Display Name</th>}
							{!gon && <th style={colTh}>Vi phạm HĐ</th>}
							{/* Meet tab · Nearby tab — Quân chốt 29/08 ẩn khỏi MỌI chỗ hiển thị.
							    · Nearby: `stationShowNearbyTab` không được trang khách nào đọc
							      (grep toàn whalelo-frontend 29/08) ⇒ cờ chết.
							    · Meet: có tác dụng thật, nhưng 0/302 station từng tắt.
							    Cột bị gỡ khỏi bảng, GIÁ TRỊ và luồng lưu giữ nguyên — bật lại
							    chỉ là bỏ hai dòng ẩn này. */}
							{/* Account */}
							<th style={colTh}>Email</th>
							{!gon && <th style={colTh}>Owner Email</th>}
							{/* Address */}
							<th style={colTh}>Address</th>
							{!gon && <th style={colTh}>Display Address</th>}
							{/* Financial */}
							{!gon && <th style={colTh}>STT Com (USD)</th>}
							{!gon && <th style={colTh}>Min Payout</th>}
							{!gon && <th style={colTh}>Pub Rate</th>}
							{!gon && <th style={colTh}>Paid (USD)</th>}
							{!gon && <th style={colTh}>Paid (Local)</th>}
							{/* Rate Limits */}
							{!gon && <th style={colTh}>Min</th>}
							{!gon && <th style={colTh}>Max</th>}
							{/* Meta */}
							<th style={colTh}>Created</th>
							{/* Actions */}
							<th style={{ ...colTh, borderRight: "none" }}>Actions</th>
						</tr>
					</thead>
					<tbody>
						{danhSach.map((val, index) => (
							<PartnerTableBody
								key={val.id || index}
								val={val}
								gon={gon}
								index={index}
								reload={props.reload}
								setIsDialogLoginOpen={setIsDialogLoginOpen}
								setOrderId={setOrderId}
								setIsDialogIfOpen={setIsDialogIfOpen}
								setOrderIdInfo={setOrderIdInfo}
								setIsDialogImages={setIsDialogImages}
								setIsDialogReviews={setIsDialogReviews}
								setIsDialogTrustItems={setIsDialogTrustItems}
								setIsDialogFeatures={setIsDialogFeatures}
								setIsDialogWalkingDistance={setIsDialogWalkingDistance}
								setIsDialogFinancialOpen={setIsDialogFinancialOpen}
								setFinancialPartner={setFinancialPartner}
								onOpenBan={(id) => {
									setBanPartnerId(id);
									setBanPartnerDialogOpen(true);
								}}
								tenChuoiDaDat={(val as any).storeId ? tenChuoiTheoStore[Number((val as any).storeId)] : undefined}
								benKy={benKyTheoTram[Number(val.id)]}
								payoutReady={payoutTheoTram[Number(val.id)]}
								selected={selectedIds.includes(val.id || "")}
								onToggleSelect={(id: string, checked: boolean) => {
									if (checked) {
										setSelectedIds((prev) => [...prev, id]);
									} else {
										setSelectedIds((prev) => prev.filter((i) => i !== id));
									}
								}}
							/>
						))}
						{props.listUser.length === 0 && (
							<tr>
								<td
									colSpan={23}
									style={{
										textAlign: "center",
										padding: "32px",
										color: "#9e9e9e",
										fontSize: "14px",
									}}>
									No stations found
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>

			{/* ── Dialogs (unchanged) ── */}
			<DialogUpdatePartnerAdmin
				openDialog={isDialogLoginOpen}
				setOpenDialog={setIsDialogLoginOpen}
				partnerId={orderId}
				reload={props.reload}
			/>
			<DialogUpdatePartnerFinancialFields
				openDialog={isDialogFinancialOpen}
				onClose={() => setIsDialogFinancialOpen(false)}
				partner={financialPartner || new Partner()}
				onSuccess={props.reload}
			/>
			<DialogInfoPartnerAdmin
				openDialog={isDialogIfOpen}
				setOpenDialog={setIsDialogIfOpen}
				partnerId={orderIdInfo}
				reload={props.reload}
				// Bản gọn: 4 việc biên tập nội dung mở thẳng từ hộp chi tiết, nên không
				// còn chiếm 4 dòng trong menu Actions của mọi hàng.
				moEdit={gon ? () => { setOrderId(orderIdInfo); setIsDialogLoginOpen(true); } : undefined}
				moImages={gon ? () => { setOrderId(orderIdInfo); setIsDialogImages(true); } : undefined}
				moReviews={gon ? () => { setOrderId(orderIdInfo); setIsDialogReviews(true); } : undefined}
				moSteps={gon ? () => { setOrderId(orderIdInfo); setIsDialogFeatures(true); } : undefined}
				moWalking={gon ? () => { setOrderId(orderIdInfo); setIsDialogWalkingDistance(true); } : undefined}
			/>
			<DialogImagesPartner
				openDialog={isDialogImages}
				setOpenDialog={setIsDialogImages}
				partnerId={orderId}
				reload={props.reload}
			/>
			<DialogWalkingDistancePartner
				openDialog={isDialogWalkingDistance}
				setOpenDialog={setIsDialogWalkingDistance}
				partnerId={orderId}
				reload={props.reload}
			/>
			<DialogReviewsPartner
				openDialog={isDialogReviews}
				setOpenDialog={setIsDialogReviews}
				partnerId={orderId}
				reload={props.reload}
			/>
			<DialogTrustItemsPartner
				openDialog={isDialogTrustItems}
				setOpenDialog={setIsDialogTrustItems}
				partnerId={orderId}
				reload={props.reload}
			/>
			<DialogFeaturesPartner
				openDialog={isDialogFeatures}
				setOpenDialog={setIsDialogFeatures}
				partnerId={orderId}
				reload={props.reload}
			/>
			<DialogBulkUpdatePartnerAdmin
				isOpen={isDialogBulkEdit}
				onClose={() => setIsDialogBulkEdit(false)}
				selectedIds={selectedIds}
				onSuccess={() => {
					setSelectedIds([]);
					props.reload();
				}}
			/>
			<DialogBanPartner
				openDialog={banPartnerDialogOpen}
				setOpenDialog={setBanPartnerDialogOpen}
				partnerId={banPartnerId}
				reload={props.reload}
			/>
		</div>
	);
}
